import { render, staticRenderFns } from "./gantt-layout.vue?vue&type=template&id=f0460dae&scoped=true&"
import script from "./gantt-layout.vue?vue&type=script&lang=ts&"
export * from "./gantt-layout.vue?vue&type=script&lang=ts&"
import style0 from "./gantt-layout.vue?vue&type=style&index=0&id=f0460dae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0460dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0460dae')) {
      api.createRecord('f0460dae', component.options)
    } else {
      api.reload('f0460dae', component.options)
    }
    module.hot.accept("./gantt-layout.vue?vue&type=template&id=f0460dae&scoped=true&", function () {
      api.rerender('f0460dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/gantt/components/gantt-layout.vue"
export default component.exports